var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pagamento-dados-nivel2-agrupado',{ref:"nivel_2_cards",attrs:{"objeto-acao":_vm.objetoAcao}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }